import { AxiosRequestConfig } from "axios";

export const slavtUrl: string =
  process.env.REACT_APP_PUBLIC_URL || "http://localhost:8080/api/v1";

export const slavtAuthUrl: string =
  process.env.REACT_APP_PUBLIC_URL || "http://localhost:8081/api/v1";

export const slavtCommunicationUrl: string =
  process.env.REACT_APP_PUBLIC_URL || "http://localhost:8082/api/v1";

export const slavt: AxiosRequestConfig = {
  url: slavtUrl,
  timeout: 6000,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
};

export const slavtAuth: AxiosRequestConfig = {
  url: slavtAuthUrl,
  timeout: 6000,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
};

export const slavtCommunication: AxiosRequestConfig = {
  url: slavtCommunicationUrl,
  timeout: 6000,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
};
